"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("@mui/material/styles");
/**
 * @ignore - internal component.
 */
var _ref = /*#__PURE__*/_react.default.createElement("ellipse", {
  cx: 165.25,
  cy: 76.52,
  rx: 9.15,
  ry: 9.5,
  transform: "rotate(-45 165.247 76.523)",
  fill: "#ffd022"
});
var HiLogoRounded = (0, _pure.default)(function (props) {
  var theme = (0, _styles.useTheme)();
  var color = props.color,
    style = props.style,
    other = (0, _objectWithoutProperties2.default)(props, ["color", "style"]);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    style: (0, _objectSpread2.default)({}, style, {
      fontSize: props.size || 24
    })
  }, other), /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 225.12 225.12"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 112.56,
    cy: 112.56,
    r: 112.56,
    fill: theme.palette.primary.main
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M166.51 97.81a8.22 8.22 0 00-9.41-1 295.58 295.58 0 01-34.2 16.45c7.61-29.15 14.82-53.16 14.94-53.54A8.23 8.23 0 10122.07 55c-.13.44-9.22 30.71-17.85 64.83A177.57 177.57 0 0184 124.66c-1.89.33-3.68.6-5.38.83A598.68 598.68 0 0196.61 66a8.23 8.23 0 00-15.4-5.79 593.94 593.94 0 00-19.81 66.3 39.21 39.21 0 01-4.89-.41 8.23 8.23 0 10-2.79 16.22 41.55 41.55 0 004.13.48c-1.25 6.25-2.38 12.61-3.33 19a8.23 8.23 0 006.92 9.36 8.48 8.48 0 001.23.09 8.23 8.23 0 008.13-7c1.09-7.28 2.43-14.57 3.92-21.72 3.6-.33 7.63-.85 12.09-1.63q6.38-1.11 12.93-2.75c-2.13 9-4.12 18-5.79 26.46a8.22 8.22 0 006.47 9.67 8.06 8.06 0 001.61.16 8.22 8.22 0 008.06-6.63c2.21-11.15 5-23.22 7.89-35.11a268.77 268.77 0 0027.82-11.5c-2 5.69-4 11.51-5.53 17a85.4 85.4 0 00-3.47 17.53c-.48 7.89 1.69 13.34 6.44 16.18a8.09 8.09 0 004.21 1.16 8.23 8.23 0 005.78-14.1c-.18-1.66-.1-6.85 4.07-20.3 3.33-10.74 8-22.82 11.48-31.63a8.24 8.24 0 00-2.27-9.23z",
    fill: theme.palette.background3
  }), _ref));
});
HiLogoRounded.muiName = 'SvgIcon';
var _default = exports.default = HiLogoRounded;